function RightPanelMobile()
{
    // Append Body Element To 'root' -----------------------------------------------------
    return(
      <>
          <div className="RightPanelBlockerMobile" id="RightPanelBlockerMobile"></div>

          <div className="FilterRightPanel" id="FilterRightPanel" style={{backgroundColor:"#FFFFFF", padding:0}}>
            <div className='BasicPaddingBalanced' style={{ width: "auto", height: "fit-content", display: "flex" }}>
                <label htmlFor='RightPanelToggleCheck' style={{marginLeft:"auto"}}>
                    <img src="/Assets/images/ButtonIcon/cancel-x-grey.svg" className="CloseButtonInsidePanel Selectable2" />
                </label>
            </div>
            <div style={{width:"auto", display:"flex", flexDirection:"column"}}>
              <button className="DropDownSelectionContainer BasicPaddingBalanced ColumnGapLong" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/home-grey.svg" />
                <p className="SignInTopDropDownText" id="DaftarMitraButtonRightText">Daftar Jadi Mitra Sekarang</p>
                <a className="HREFInsideContainer" href="https://listing.pingingo.com/"></a>
              </button>
              <button className="DropDownSelectionContainer BasicPaddingBalanced ColumnGapLong RemoveIfNotLogin" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/pingicon.svg" />
                <p className="SignInTopDropDownText" id="MyPingButtonRightText">Perjalanan Saya</p>
                <a className="HREFInsideContainer" href="/myping/id"></a>
              </button>
              <button className="DropDownSelectionContainer BasicPaddingBalanced ColumnGapLong RemoveIfNotLogin" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/ProfileIcon.svg" />
                <p className="SignInTopDropDownText" id="ProfileButtonRightText">Profil</p>
                <a className="HREFInsideContainer" href="/myprofile/id"></a>
                
              </button>
              <button className="DropDownSelectionContainer BasicPaddingBalanced ColumnGapLong RemoveIfNotLogin" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/referralicon.svg" />
                <p className="SignInTopDropDownText" id="ReferralButtonRightText">Referral</p>
                <a className="HREFInsideContainer" href="/referral/id"></a>
              </button>
              <button className="DropDownSelectionContainer BasicPaddingBalanced ColumnGapLong RemoveIfNotLogin" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/ticket-voucher.svg" />
                <p className="SignInTopDropDownText" id="MyVoucherButtonRightText">Voucher Saya</p>
                <a className="HREFInsideContainer" href="/vouchermenu/id"></a>
              </button>
              <div className="wrap-collabsible">
                <input id="ToggleLangMobile" className="CollapsibleToggleInput" type="checkbox" style={{display:"none"}} />
                <label htmlFor="ToggleLangMobile" className="DropDownSelectionContainer BasicPaddingBalanced ColumnGapLong" style={{width:"auto"}}>
                  <div className="BasicIconInsideInput" style={{marginLeft:0}}>
                    <div className="UserTopProfileIcon BasicThinGreyBorder Selectable2">
                    <img src="/Assets/images/CountryCode/Indonesia.svg" id="LanguageNowRightPanelIcon" className="ImageFullCover"/>
                    </div>
                  </div>
                  <p className="SignInTopDropDownText" id="LanguageNowRightPanelText" style={{width:"fit-content"}}>Indonesia</p>
                  <img className="BasicInputFieldChevronIconSearch ChevronforCollapsible" src='/Assets/images/ButtonIcon/chevron-grey.svg'></img>
                </label>
                <div className="collapsible-content" id="CollapsibleLanguageDropDownRight">
                  <button className="DropDownSelectionContainer BasicPaddingBalanced ColumnGapBasic" style={{backgroundColor:"#f5f5f5", height:"fit-content"}}>
                    <img src="/Assets/images/CountryCode/Indonesia.svg" className="BasicIconInsideInput2" style={{height:"fit-content"}}/>
                    <p className="SignInTopDropDownText" style={{color:"#353535"}}>Indonesia</p>
                  </button>
                  <button className="DropDownSelectionContainer BasicPaddingBalanced ColumnGapBasic" style={{backgroundColor:"#f5f5f5", height:"fit-content"}}>
                    <img src="/Assets/images/CountryCode/UnitedKingdom.svg" className="BasicIconInsideInput2" style={{height:"fit-content"}}/>
                    <p className="SignInTopDropDownText" style={{color:"#353535"}}>English</p>
                  </button>
                </div>
              </div>
              <button className="DropDownSelectionContainer BasicPaddingBalanced ColumnGapLong RemoveIfNotLogin" id="SignOutRightButton" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/signout.svg" />
                <p className="SignInTopDropDownText" id="SignOutButtonRightText">Keluar</p>
              </button>
              <button className="DropDownSelectionContainer BasicPaddingBalanced ColumnGapLong RemoveIfLoggedin" id="LoginRightButton" style={{width:"auto"}}>
                <img className="BasicIconInsideInput" style={{marginLeft:0}} src="/Assets/images/ButtonIcon/login.png" />
                <p className="SignInTopDropDownText" id="LoginButtonRightText">Login</p>
              </button>
            </div>
          </div>

      </>
    )
}

export default RightPanelMobile